import './src/styles/tailwind.css'
import './src/styles/fonts.scss'
import './src/styles/markdown/markdown.css'
import './src/styles/markdown/highlightjs.css'
import './src/styles/markdown/markdown-it-admonition.css'